import { useState } from "react";
import { Table } from "react-bootstrap";
import TablePagination from "../../pagination/TablePagination";
import { ITEMS_PER_PAGE } from "../../../../../constant/constant";
import "../../../../../common/styles/table.css";
import ClassroomTableRow from "./ClassroomTableRow";

/**
 * @typedef {import("../../../../../hooks/teacher/classroom/useGetClassroomById").StudentType} StudentType
 */

/**
 * @typedef {Object} ClassroomTableProps
 * @property {StudentType[]} students - Array of student objects
 */

/**
 * ClassroomTable component displays a paginated table of students
 * @param {ClassroomTableProps} props
 * @param {"school-admin" | "teacher"} props.type - Type of user
 * @returns {JSX.Element}
 */
const ClassroomTable = ({ students, type }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(students.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const currentStudents = students.slice(startIndex, endIndex);

  return (
    <div className="custom-table-container mt-3">
      <div className="custom-table-wrapper">
        <Table hover className="custom-table">
          <thead className="custom-table-head">
            <tr>
              <th>Student ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {currentStudents.map((student) => {
              return <ClassroomTableRow key={student.id} student={student}
                type={type} />;
            })}
          </tbody>
        </Table>
      </div>

      <TablePagination
        totalPage={totalPages}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default ClassroomTable;
